/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.composable.question

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Div
import systems.frictionless.impulse.browser.composable.component.RadioChoice
import systems.frictionless.impulse.browser.style.AppStyleSheet
import systems.frictionless.impulse.rest.model.Answer
import systems.frictionless.impulse.rest.model.Index
import systems.frictionless.impulse.rest.model.LikertFour
import systems.frictionless.impulse.rest.model.Question

@Composable
internal fun LikertFour(
    questionType: Question.Type.Likert,
    answerValue: Answer.Type.Likert?,
    setAnswerValue: (Answer.Type.Likert) -> Unit,
    name: String = "likert-four"
) {
    Div(attrs = {
        classes(AppStyleSheet.questionMultiChoiceBox)
    }) {
        val values = LikertFour.values()
        values.forEachIndexed { index, item ->
            val select: () -> Unit = {
                setAnswerValue(Answer.Type.Likert(item))
            }
            RadioChoice(
                label = item.text(questionType),
                isSelected = item == answerValue?.likertFour,
                name = name,
                index = Index(index),
                onSelected = select
            )
        }
    }
}

/**
 * @return The text to display in the UI for the user.
 */
fun LikertFour.text(type: Question.Type.Likert) =
    when (type.form) {
        Question.Type.Likert.Form.Agreement ->
            when (this) {
                LikertFour.StronglyDisagree -> "Strongly disagree"
                LikertFour.SlightlyDisagree -> "Slightly disagree"
                LikertFour.SlightlyAgree -> "Slightly agree"
                LikertFour.StronglyAgree -> "Strongly agree"
            }
        Question.Type.Likert.Form.Frequency ->
            when (this) {
                LikertFour.StronglyDisagree -> "Very rarely"
                LikertFour.SlightlyDisagree -> "Rarely"
                LikertFour.SlightlyAgree -> "Frequently"
                LikertFour.StronglyAgree -> "Very frequently"
            }
    }
